export default "__VITE_ASSET__pE_DKVlO__"